// Utility functions for PWA Share Target file handling

// Retrieve shared file from service worker cache
export async function getSharedFile() {
    try {
        const response = await fetch('/get-shared-file');

        if (!response.ok) {
            if (response.status === 404) {
                return null;
            }
            throw new Error('Failed to retrieve shared file');
        }

        const blob = await response.blob();
        const fileName = decodeURIComponent(response.headers.get('X-File-Name') || 'shared-audio');
        const lastModified = parseInt(response.headers.get('X-File-Last-Modified') || Date.now().toString(), 10);

        // Create a File object from the blob
        const file = new File([blob], fileName, {
            type: blob.type,
            lastModified: lastModified
        });

        return file;
    } catch (error) {
        console.error('Error retrieving shared file:', error);
        return null;
    }
}

// Clear shared file from service worker cache
export async function clearSharedFile() {
    try {
        await fetch('/clear-shared-file');
    } catch (error) {
        console.error('Error clearing shared file:', error);
    }
}
